(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_header"]) return;
  try {
    
  document.addEventListener(
    'toggle',
    (event) => {
      const panel = event.target;
      if (!(panel instanceof HTMLDetailsElement) || !panel.matches('.c_js-header-panel') || !panel.open) return;

      // Menu と Search は同時に開かない
      document.querySelectorAll('.c_js-header-panel[open]').forEach((other) => {
        if (other !== panel) other.open = false;
      });

      // パネルをヘッダーの下端から画面下端まで敷くため、開いた時点のヘッダー位置を渡す
      const bottom = panel.closest('.c_c-header').getBoundingClientRect().bottom;
      panel.style.setProperty('--_panel-top', `${bottom}px`);
      panel.querySelector('.c_js-header-search-input')?.focus();
    },
    true
  );

  // 追従中は商品情報の sticky やページ内リンクの移動先がヘッダーに隠れるため、ヘッダーの高さを渡す
  let stickyHeaderObserver;
  const observeStickyHeader = () => {
    stickyHeaderObserver?.disconnect();
    document.documentElement.style.removeProperty('--sticky-header-height');
    const header = document.querySelector('.c_l-header--sticky .c_c-header');
    if (!header) return;
    stickyHeaderObserver = new ResizeObserver(([entry]) => {
      document.documentElement.style.setProperty('--sticky-header-height', `${entry.borderBoxSize[0].blockSize}px`);
    });
    stickyHeaderObserver.observe(header);
  };
  observeStickyHeader();
  // エディタでヘッダーのセクションが描画し直された・消されたときだけ監視をやり直す。ほかのセクションでは値を消さない
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.c_l-header')) observeStickyHeader();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target.querySelector('.c_l-header')) return;
    stickyHeaderObserver?.disconnect();
    document.documentElement.style.removeProperty('--sticky-header-height');
  });

  document.addEventListener('keyup', (event) => {
    if (event.code !== 'Escape') return;
    const panel = document.querySelector('.c_js-header-panel[open]');
    if (!panel) return;
    panel.open = false;
    panel.querySelector('summary').focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_search"]) return;
  try {
    
  // 検索フォームは type=product で商品だけを検索させる。type の無い URL（外部リンク・ブックマーク）は件数とページ送りに商品以外が混ざるため、付け直して読み込み直す
  if (document.querySelector('.c_js-search-results')) {
    const url = new URL(window.location.href);
    if (url.searchParams.get('type') !== 'product') {
      url.searchParams.set('type', 'product');
      window.location.replace(url);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
